angular.module('TetherApp').factory('clientRoleService', [
    '$http',
    function($http) {

        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let deleteClientRole = function (id) {
            let uri = '/api/v1/client-role/' + id + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.delete(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            deleteClientRole: deleteClientRole
        }
    }
]);
